<div class="account-header" *ngIf="Device === DTypes.Desktop && AccountHeaderDisplay">
  <div class="account-header__wrapper animated faster fadeIn" *ngIf="!AccountHeaderUser">
    <div class="account-header__icon">
      <span class="mr-icon mr-icon-user">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </div>
    <div class="account-header__initial">
      <a (click)="onSignInURL($event)">Вход</a>
      <a (click)="onSignUpURL($event)">Регистрация</a>
    </div>
  </div>

  <div class="account-header__wrapper p-menu__toggle-link animated faster fadeIn" *ngIf="AccountHeaderUser"
    (click)="menu.toggle($event)">

    <div class="account-header__icon">
      <p-badge severity="danger" *ngIf="AccountHeaderNotify > 0"
        [value]="AccountHeaderNotify"
        [styleClass]="'p-badge__notify'">
      </p-badge>

      <div class="account-header__avatar" *ngIf="AccountHeaderUser.picPath">
        <img src="{{StaticURL}}{{AccountHeaderUser.picPath}}" (error)="onAccountErrorPicPath()">
      </div>

      <span class="mr-icon mr-icon-user" *ngIf="!AccountHeaderUser.picPath">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </div>

    <div class="account-header__profile">
      <div class="account-header__profile-value">
        <p>{{AccountHeaderUser.username}}</p>
      </div>
    </div>
  </div>

  <p-menu #menu [popup]="true" [model]="AccountHeaderMenu" [appendTo]="'body'" [styleClass]="'p-menu__profile'"></p-menu>
</div>


<div class="account-header" *ngIf="Device === DTypes.Mobile && AccountHeaderDisplay">
  <p-badge severity="danger" *ngIf="AccountHeaderNotify > 0"
    [value]="AccountHeaderNotify"
    [styleClass]="'p-badge__notify'">
  </p-badge>

  <span class="mr-icon mr-icon-user" *ngIf="!AccountHeaderUser || !AccountHeaderUser?.picPath">
    <span class="path1"></span>
    <span class="path2"></span>
  </span>

  <div class="account-header__wrapper"
    *ngIf="AccountHeaderUser"
    ngClass="{{(deviceValue | async) === DTypes.Tablet || (deviceValue | async) === DTypes.Mobile ? 'p-0' : ''}}">

    <div class="account-header__avatar" *ngIf="AccountHeaderUser?.picPath">
      <img src="{{StaticURL}}{{AccountHeaderUser?.picPath}}" (error)="onAccountErrorPicPath()">
    </div>
  </div>
</div>
